import declare from "dojo/_base/declare";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Ref from "csi/heading/Ref";

export = declare(Ref, {
	/**
	 * @override
	 * Ignore invalid entries
	 */
	getStoreOptions(ctx: Context, h: Heading): Record<string, any> {
		return { ignoreInvalid: true };
	},
});